import React from "react";
import styled from "styled-components";
import FsImage from "../../../assets/images/fs.png";
import BOBrandImage from "../../../assets/images/bobrand.png";
import StockImage from "../../../assets/images/stock.png";
import MBrandImage from "../../../assets/images/mbrand.png";
import CloseBtn from "../../../assets/icons/x-close.svg";
const StyledPage = styled.div`
    &.popup-container {
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 32px 24px;
        background-color: #1e2631;
        border-radius: 4px;
        width: 1400px;
        height: 616px;
        justify-content: space-between;
        position: relative;
    }
    .popup-header {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .popup-title {
        font-size: 20px;
        font-weight: 700;
    }
    .popup-content {
        height: 430px;
        display: flex;
        gap: 32px;
    }
    .popup-grrouped {
        width: 314px;
        display: flex;
        flex-direction: column;
        text-align: left;
        gap: 16px;
    }
    .popup-grrouped .desc {
        display: flex;
        width: 100%;
        justify-content: center;
        align-items: center;
        gap: 8px;
    }
    .popup-grrouped .description-icon .number {
        height: 14px;
        width: 14px;
        background: #ff9900;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50px;
        font-size: 7px;
    }
    .title {
        font-weight: 700;
    }
    .popup-footer {
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: center;
        gap: 10px;
    }
    .description-text {
        font-weight: 400;
    }
    .popup-button {
        width: 150px;
        height: 35px;
        background: #10141b;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px;
        text-transform: uppercase;
        cursor: pointer;
    }
    .popup-grrouped .banner {
        background: #10141b;
        padding: 20px 0px 0px 25px;
        border-radius: 5px;
    }
    img.x-close {
        position: absolute;
        right: 10px;
        top: 10px;
        cursor: pointer;
    }
`;
export default function FrontSystemPopup({ closePopup, handleGuidelineAction }) {
    return (
        <StyledPage className="popup-container">
            <div className="popup-header">
                <div className="popup-title">Why Integrate With Front Systems</div>
            </div>
            <div className="popup-content">
                <div className="popup-grrouped">
                    <div className="banner">
                        <img src={FsImage} alt="Banner" style={{ width: "100%", height: "auto" }} />
                    </div>
                    <div className="title">Get orders from remote shoppers directly in Front Systems.</div>
                    <div className="desc">
                        <div className="description-icon">
                            <div className="number">1</div>
                        </div>
                        <div className="description-text">
                            HeyBO users will buy from your store. Their orders will show up as sales ready to be
                            registered as a normal in-store sale.
                        </div>
                    </div>
                    <div className="desc">
                        <div className="description-icon">
                            <div className="number">2</div>
                        </div>
                        <div className="description-text">
                            You’ll be able to offer pick-up in store, courier to a location in the same hour or shipping
                            to an address.
                        </div>
                    </div>
                </div>

                <div className="popup-grrouped">
                    <div className="banner">
                        <img src={StockImage} alt="Banner" style={{ width: "100%", height: "auto" }} />
                    </div>
                    <div className="title">
                        Get your stock monitored by BOtag AI so you don’t lose business at any time.
                    </div>
                    <div className="desc">
                        <div className="description-icon">
                            <div className="number">1</div>
                        </div>
                        <div className="description-text">
                            Let BOtag AI work as a store manager assistant, monitoring your stock in real-time.
                        </div>
                    </div>
                    <div className="desc">
                        <div className="description-icon">
                            <div className="number">2</div>
                        </div>
                        <div className="description-text">
                            BOtag AI will detect fast-movers during their high-peak of sales and recommend reorders.
                        </div>
                    </div>
                    <div className="desc">
                        <div className="description-icon">
                            <div className="number">3</div>
                        </div>
                        <div className="description-text">
                            BOtag AI will detect slow-movers and create BOimages to turn them into fast-movers.
                        </div>
                    </div>
                </div>

                <div className="popup-grrouped">
                    <div className="banner">
                        <img src={BOBrandImage} alt="Banner" style={{ width: "100%", height: "auto" }} />
                    </div>
                    <div className="title">Get reorders suggestions and BOimages from Brands</div>
                    <div className="desc">
                        <div className="description-icon">
                            <div className="number">1</div>
                        </div>
                        <div className="description-text">
                            Fast-movers will trigger reorders. If you agree with them, they’re automatically sent to the
                            brand, keeping the sales moment high.
                        </div>
                    </div>
                    <div className="desc">
                        <div className="description-icon">
                            <div className="number">2</div>
                        </div>
                        <div className="description-text">
                            Slow-movers will trigger a bigger effort request from the brand so they can act immediately
                            and create BOimages to land sales in your POS.
                        </div>
                    </div>
                </div>

                <div className="popup-grrouped">
                    <div className="banner">
                        <img src={MBrandImage} alt="Banner" style={{ width: "100%", height: "auto" }} />
                    </div>
                    <div className="title">Get product master data directly from Brands</div>
                    <div className="desc">
                        <div className="description-icon">
                            <div className="number">1</div>
                        </div>
                        <div className="description-text">
                            Once connected to BOtag, you’ll get product master data directly from brands. BOtag AI
                            learns from each brand and adapt the entire setup so it’s compatible with your POS
                        </div>
                    </div>
                    <div className="desc">
                        <div className="description-icon">
                            <div className="number">2</div>
                        </div>
                        <div className="description-text">
                            New products are created and existing products are updated. You can still customize fields.
                        </div>
                    </div>
                </div>
            </div>
            <div className="popup-footer">
                <div className="popup-button" onClick={closePopup}>
                    CLOSE
                </div>
                <div className="popup-button" onClick={handleGuidelineAction}>
                    GUIDELINES
                </div>
            </div>
            <img className="x-close" src={CloseBtn} alt="" onClick={closePopup} />
        </StyledPage>
    );
}
